import './ccf-sms-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfSmsIconProps extends SvgIconProps {
  fillColor?: string;
}
/**
 * component used to display sms icon
 * @param props - CcfSmsIconProps
 * @example - <CcfSmsIcon />
 * @returns SVG of sms icon
 */
export function CcfSmsIcon(props: CcfSmsIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_SMS">
        <g
          id="Channel_Type"
          data-name="Channel Type"
          transform="translate(5.5 3)"
        >
          <g
            id="Icon_Interaction_Type"
            data-name="Icon Interaction Type"
            transform="translate(-9 -6)"
          >
            <g id="smediatype-sms" transform="translate(-28.063 11.5)">
              <g id="Icons">
                <path
                  id="Path_12739"
                  data-name="Path 12739"
                  d="M21.089,9.342V8.395A1.876,1.876,0,0,0,19.232,6.5H11.92a1.876,1.876,0,0,0-1.857,1.895V22.605A1.876,1.876,0,0,0,11.92,24.5h7.312a1.876,1.876,0,0,0,1.857-1.895V18.816H19.232v1.421a.469.469,0,0,1-.464.474H12.384a.469.469,0,0,1-.464-.474V8.868a.469.469,0,0,1,.464-.474h6.383a.469.469,0,0,1,.464.474v.474ZM14.647,21.658H16.5a.948.948,0,0,1,0,1.895H14.647a.948.948,0,0,1,0-1.895Zm8.416-8.526v1.895a1.876,1.876,0,0,1-1.857,1.895H17.492l-1.857,1.895V16.921a1.876,1.876,0,0,1-1.857-1.895V13.132a1.876,1.876,0,0,1,1.857-1.895h5.571A1.876,1.876,0,0,1,23.063,13.132Z"
                  transform="translate(27 -12)"
                  fill={props.fillColor ? props?.fillColor : '#1c8dfc'}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfSmsIcon;
